/**
 * Admin portal auth configuration
 *
 * Uses @mzanzi/auth shared package for MSAL setup.
 * Admin-specific: staff domain/email validation, separate redirect URIs.
 */
import { createMsalConfig, type UseAuthOptions } from '@mzanzi/auth';

const TENANT_NAME = 'mzanzi';
const TENANT_ID = 'b3551fcd-fe0d-437a-b90c-499156bc8a84';
const CLIENT_ID = import.meta.env.VITE_ENTRA_CLIENT_ID || '9d23bd8d-5c3c-40b4-85da-7b1962886096';

function getRedirectUri(): string {
  if (import.meta.env.DEV) return 'http://localhost:5174/auth/callback';
  if (typeof window !== 'undefined' && window.location.hostname.includes('pages.dev')) {
    return `${window.location.origin}/auth/callback`;
  }
  return 'https://admin.mzanzi.cloud/auth/callback';
}

function getPostLogoutUri(): string {
  if (import.meta.env.DEV) return 'http://localhost:5174';
  if (typeof window !== 'undefined' && window.location.hostname.includes('pages.dev')) {
    return window.location.origin;
  }
  return 'https://admin.mzanzi.cloud';
}

export const msalConfig = createMsalConfig({
  tenantName: TENANT_NAME,
  tenantId: TENANT_ID,
  clientId: CLIENT_ID,
  redirectUri: getRedirectUri(),
  postLogoutRedirectUri: getPostLogoutUri(),
});

/** Staff email domains allowed to access admin portal */
const ALLOWED_STAFF_DOMAINS = ['smcit.co.za'];

/** Specific email addresses allowed (contractors, external collaborators) */
const ALLOWED_STAFF_EMAILS: string[] = [];

function isStaffEmail(email: string): boolean {
  const lower = email.toLowerCase();

  if (ALLOWED_STAFF_EMAILS.some((e) => e.toLowerCase() === lower)) {
    return true;
  }

  const domain = lower.split('@')[1];
  return ALLOWED_STAFF_DOMAINS.some((d) => d.toLowerCase() === domain);
}

/** Auth options for admin portal — includes staff domain check */
export const adminAuthOptions: UseAuthOptions = {
  isStaffCheck: isStaffEmail,
};
